<ng-container *ngIf="questionState$ | async"></ng-container>
<csl-support-chat
  (messageSent)="sendMessage($event)"
  [myId]="getSupportChatMyId()"
  [questionId]="question?.id"
  [actionButtons]="actionButtons"
  [question]="question"></csl-support-chat>
